import { Create, SimpleForm } from 'react-admin';
import { SlideForm } from './SlideForm.jsx';

export const SlideCreate = () => (
  <Create redirect="list">
    <SimpleForm><SlideForm /></SimpleForm>
  </Create>
);
